import axios from 'axios';

export default {
  pre_insercion(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_compp_infcorredor.pre_insercion",
				"p_args_in": JSON.stringify({
          "p_usuario": p_usuario
				})
			})
	},

	recuperar(p_email, p_usuario, p_ano){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_infcorredor.recuperar",
			"p_args_in": JSON.stringify({
			"p_usuario": p_usuario,
			"p_ano": p_ano
				})
		})
	},

}
